function countSelectedFacets(form) {
  let n = form.querySelectorAll('input[name^="filter."]:checked').length;
  if (form.querySelector('input[name="filter.v.price.gte"]')?.value) n++;
  else if (form.querySelector('input[name="filter.v.price.lte"]')?.value) n++;
  return n;
}

function syncApplyButtonLabel(btn, form) {
  const c = countSelectedFacets(form);
  const next = btn.textContent.replace(/\(\d+\)/, `(${c})`);
  if (next !== btn.textContent) {
    btn.textContent = next;
  }
}

function initFacetApplyCounter(form) {
  const formId = form.id;
  if (!formId) return;

  const btn = document.querySelector(`button[type="submit"][form="${formId}"]`);
  if (!btn) return;

  form._facetApplyCounterAbort?.abort();
  form._facetApplyCounterAbort = new AbortController();
  const { signal } = form._facetApplyCounterAbort;

  function sync() {
    syncApplyButtonLabel(btn, form);
  }

  form.addEventListener('change', sync, { signal });
  form.addEventListener('reset', () => requestAnimationFrame(sync), { signal });
  sync();
}

function initAllFacetDrawerApplyCounters() {
  document.querySelectorAll('form.facets--drawer').forEach(initFacetApplyCounter);
}

initAllFacetDrawerApplyCounters();

document.addEventListener('facet:morph-complete', () => {
  initAllFacetDrawerApplyCounters();
});
